import React, { createContext } from "react";

const ExternalReportContext = createContext();

export const ReportContextProvider = ExternalReportContext.Provider;

export default ExternalReportContext;
